import { FloatingIndicator, Tabs } from '@mantine/core';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';

import styles from './InfosAndContactsMainPage.module.scss';

const VALID_TABS = ['contacts', 'infos'] as const;
type TabValue = (typeof VALID_TABS)[number];

const InfosAndContactsMainPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const rootRef = useRef<HTMLDivElement>(null);
  const controlsRefs = useRef<Record<string, HTMLButtonElement | null>>({});
  const { t } = useTranslation();
  const assetId = useCurrentAssetId();

  const getCurrentTab = (pathname: string): TabValue => {
    const segments = pathname.split('/');
    const found = segments.find(s => (VALID_TABS as readonly string[]).includes(s));
    return (found as TabValue | undefined) ?? 'contacts';
  };

  const [currentTab, setCurrentTab] = useState<TabValue>('contacts');

  useEffect(() => {
    setCurrentTab(getCurrentTab(location.pathname));
  }, [location.pathname]);

  const handleTabChange = (value: string | null) => {
    if (value && assetId) navigate(`/asset/${assetId}/infos-et-contacts/${value}`);
  };

  return (
    <div className={styles.container}>
      <Tabs value={currentTab} onChange={handleTabChange} className={styles.tabs}>
        <Tabs.List ref={rootRef} className={styles.tabList}>
          <Tabs.Tab ref={node => (controlsRefs.current['contacts'] = node)} value="contacts">
            {t('infoAndContacts.tab.contacts', 'Contacts')}
          </Tabs.Tab>
          <Tabs.Tab ref={node => (controlsRefs.current['infos'] = node)} value="infos">
            {t('infoAndContacts.tab.infos', 'Infos pratiques')}
          </Tabs.Tab>

          <FloatingIndicator
            parent={rootRef.current}
            target={currentTab ? controlsRefs.current[currentTab] : null}
            className={styles.indicator}
          />
        </Tabs.List>

        <Outlet />
      </Tabs>
    </div>
  );
};

export default InfosAndContactsMainPage;
